import { render } from "./Education.vue?vue&type=template&id=fb95f770&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"

import "./Education.vue?vue&type=style&index=0&id=fb95f770&scoped=true&lang=css"

import exportComponent from "/home/tobi/Documents/workspace/ytobi.github.io-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb95f770"]])

export default __exports__